import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceService } from '../../service.service';

interface Department {
  _id: string;
  idea_department_name: string;
  idea_department_head_id: string | null;
  idea_department_head_name: string | null;
}

@Component({
  selector: 'app-department-master-listing',
  templateUrl: './department-master-listing.component.html',
  styleUrls: ['./department-master-listing.component.css']
})
export class DepartmentMasterListingComponent implements OnInit {
  deptList: Department[] = [];
  filteredDeptList: Department[] = [];

  isLoading = false;
  loadError: string | null = null;

  searchText = '';

  constructor(
    private apiService: ServiceService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadDepartments();
  }

  goBack(): void {
    this.router.navigate(['admin/hrm-menu/vacation-monitoring'], {
      state: { returnToSettings: true }
    });
  }

  loadDepartments(): void {
    this.isLoading = true;
    this.loadError = null;

    this.apiService.ideasuggestiondepartmentDropdown().subscribe({
      next: (res: any) => {
        this.isLoading = false;
        if (res && res.success && Array.isArray(res.data)) {
          this.deptList = res.data;
          this.applyFilters();
        } else {
          this.deptList = [];
          this.filteredDeptList = [];
          this.loadError = 'Unable to load departments.';
        }
      },
      error: (err: any) => {
        console.error('Error loading department list:', err);
        this.isLoading = false;
        this.deptList = [];
        this.filteredDeptList = [];
        this.loadError = 'Failed to load department data from server.';
      }
    });
  }

  reload(): void {
    this.loadDepartments();
  }

  applyFilters(): void {
    const term = this.searchText.trim().toLowerCase();

    if (!term) {
      this.filteredDeptList = [...this.deptList];
      return;
    }

    this.filteredDeptList = this.deptList.filter((d) => {
      const dept = (d.idea_department_name || '').toLowerCase();
      const head = (d.idea_department_head_name || '').toLowerCase();
      return dept.includes(term) || head.includes(term);
    });
  }

  editDepartment(item: Department): void {
    this.router.navigate(['/admin/department-master-edit'], {
      queryParams: { department_id: item._id }
    });
  }

  onRowClick(item: Department): void {
    // Hook for future detail view if needed
  }

  trackByDept(index: number, item: Department): string {
    return item._id || index.toString();
  }
}